import React from "react";
import { INVALID_VALUE } from "@src/constants/InvalidValue";
export const getUserColumns = () => [
    {
        Header: "파트너 번호",
        accessor: "no",
        Cell: ({ cell: { value } }: any) => (
            <div
                style={{
                    width: "100%",
                    minWidth: "50px",
                    height: "50px",
                    textAlign: "center",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                {value ? value : INVALID_VALUE}
            </div>
        ),
    },
    {
        Header: "회원 번호",
        accessor: "userNo",
        Cell: ({ cell: { value } }: any) => (
            <div style={{ minWidth: "80px", width: "100%", textAlign: "center" }}>{value ? value : INVALID_VALUE}</div>
        ),
    },
    {
        Header: "이름",
        accessor: "uname",
        Cell: ({ cell: { value } }: any) => (
            <div
                style={{
                    minWidth: "80px",
                    width: "100%",
                    textAlign: "center",
                }}
            >
                {value ? value : INVALID_VALUE}
            </div>
        ),
    },
    {
        Header: "아이디",
        accessor: "comments",
        Cell: ({ cell: { value } }: any) => (
            <div
                style={{
                    minWidth: "160px",
                    width: "100%",
                    textAlign: "center",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                }}
            >
                {value ? value : INVALID_VALUE}
            </div>
        ),
    },
    {
        Header: "파트너 코드",
        accessor: "partnerCode",
        Cell: ({ cell: { value }, row }: any) => {
            return (
                <div
                    style={{
                        minWidth: "180px",
                        width: "100%",
                        textAlign: "center",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                    }}
                >
                    {value ? value : INVALID_VALUE}
                </div>
            );
        },
    },
];
